import React from "react";
import FrontHeader from "../../shared/FrontHeader/FrontHeader";
import FrontFooter from "../../shared/FrontFooter/FrontFooter";
import illustration from "../../../assets/images/appImages/illustration.png";
import { TeamData } from "./data";


export const CustomBeautyTitle = ({ title }: { title: string }) => {
  return <h2 className="custom-esb-title">{title}</h2>;
};

const TeamCard = ({
  photo,
  name,
  role,
  twitter,
  facebook,
  linkedin,
}: {
  photo?: string;
  name: string;
  role: string;
  twitter?: string;
  facebook?: string;
  linkedin?: string;
}) => {
  return (
    <div className="team-card">
      <span className="photo-wrapper">
        <img loading="lazy" src={photo} alt="photo" />
      </span>
      <span className="name">{name}</span>
      <span className="role">{role}</span>
    </div>
  );
};



function WhoWeAre() {
  return (
    <div className="landing-page-component">
      <FrontHeader />
      <div className="page-content who-we-are-page pb-5 pb-5">
        <h1 className="custom-page-title">Qui sommes-nous ?</h1>
        <div className="who-we-are">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mb-4">
                <div className="illustration-container">
                  <img loading="lazy" src={illustration} alt="image" />
                </div>
              </div>
              <div className="col-md-6 mb-4">
                <CustomBeautyTitle title="Qui sommes nous?" />
                <h3 className="custom-title">
                  Les Artisanes beauté
                </h3>
                <div className="custom-content">
                  Melamossa est une marque de soins naturels, créée par le GIE Les Artisanes Beauté.
                  Inspirée des richesses du terroir sénégalais, elle propose des produits de qualité, formulés
                  à base d’ingrédients locaux, pour prendre soin de la peau et des cheveux avec douceur,
                  efficacité et dans le respect de la santé et du bien-être de nos clients
                </div>
              </div>
              <div className="col-md-12 mb-4">
                <div className="custom-content">
                  Chez les Artisanes beauté, nous prônons une approche naturelle, saine et inclusive de la beauté.
                  Nous valorisons les richesses du terroir sénégalais à travers des soins efficaces formulés avec
                  des ingrédients locaux, respectueux de toutes les peaux. Ancrés dans un savoir-faire authentique,
                  nous œuvrons pour un bien-être global — intérieur comme extérieur — avec exigence, éthique et fierté.
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 our-team gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Team" />
              <h3 className="custom-title">Notre équipe</h3>
              <div className="row pt-4">
                {!!TeamData &&
                  TeamData.map((member, key) => {
                    return (
                      <div className="col-lg-4 col-md-4 mb-4 card-wrapper" key={key}>
                        <TeamCard
                          photo={member.photo}
                          name={member.name}
                          role={member.role}
                        />
                      </div>
                    );
                  })}
              </div>
            </div>
          </div>

          <div className="my-5 py-5 founder-words gray_sky">
            <div className="container">
              <CustomBeautyTitle title="Qui sommes nous" />
              <h3 className="custom-title">
                Mot de la fondatrice
              </h3>
              <div className="row pt-4">
                <div className="col-md-12 col-lg-12 col-wrapper">
                  <div className="founder-card green_colgate__card">
                    <div className="custom-content">
                      Bienvenue dans l’univers d’AMLYS.
                      <br /><br />
                      Il y a plus de 25 ans, portée par l’amour du beau, du travail bien fait
                      et du riche patrimoine textile africain, j’ai fondé l'activité avec
                      l’ambition de valoriser l’artisanat traditionnel, en particulier le
                      pagne tissé à la main, à travers des créations modernes et raffinées.
                      <br /><br />
                      Chaque pièce AMLYS raconte une histoire : celle de nos traditions, de
                      notre identité, et de la créativité sans cesse renouvelée de nos artisans.
                      Mon souhait a toujours été de faire dialoguer héritage et modernité,
                      pour proposer des accessoires qui ont du sens, du caractère et une âme.
                      <br /><br />
                      Aujourd'hui, je suis fière de voir cet héritage porté avec passion et
                      dynamisme par ma fille, qui a repris la direction de l'activité pour
                      continuer à faire rayonner notre vision et nos valeurs au-delà des
                      frontières.
                      <br /><br />
                      Merci de faire partie de cette aventure humaine et culturelle.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

      </div>
      <div style={{ padding: '5rem 0' }}></div>
      <FrontFooter />
    </div>
  );
}

export default WhoWeAre;
